module.exports = __webpack_public_path__ + "img/ites.f2fdf64b.png";